var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.538 0H13.461V25H11.538z","key":0}),React.createElement("path",{"d":"M0 11.538H25V13.461H0z","key":1})]);
}

PlusIcon.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
